import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { setPropTypes, compose, withProps } from 'recompose'

import SearchResultsEmptyState from './SearchResultsEmptyState'
import ListingGroup from './ListingGroup'
import Breadcrumbs from '../../Shared/Breadcrumbs/Breadcrumbs'
import { fromServerToClient } from '../../../lib/utils/collection'

const enhance = compose(
  inject('store'),
  withProps(({ store }) => ({
    listingsStore: store
  })),
  setPropTypes({
    listingsStore: PropTypes.object.isRequired,
    breadcrumbs: PropTypes.array,
    collection: PropTypes.array,
    header: PropTypes.string,
    isSortingOn: PropTypes.bool,
    trendingUrl: PropTypes.string,
    totalCount: PropTypes.number
  }),
  observer
)

const SearchListings = enhance(
  ({ listingsStore, breadcrumbs = [], header, isSortingOn, collection = [], totalCount }) => {
    const [isHydrated, setIsHydrated] = useState(false)

    useEffect(() => {
      listingsStore.setInitialState({
        collection: fromServerToClient(collection),
        totalCount,
        breadcrumbs,
        header
      })

      setIsHydrated(true)

      window.addEventListener('popstate', () => window.location.reload())
      return () => window.removeEventListener('popstate', () => window.location.reload())
    }, [])

    const currentCollection = isHydrated ? listingsStore.collection : fromServerToClient(collection)
    const currentTotal = isHydrated ? listingsStore.totalCount : totalCount
    const currentHeader = isHydrated ? listingsStore.header : header
    const currentBreadcrumbs = isHydrated ? listingsStore.breadcrumbs : breadcrumbs

    const fallbackMarkListingAsSaved = () => {
      // No-op during SSR to prevent errors
    }

    const currentMarkListingAsSaved = isHydrated ? listingsStore.updateSaveStatus : fallbackMarkListingAsSaved

    return (
      <React.Fragment>
        <div className='Srp-breadcrumbs'>
          <Breadcrumbs breadcrumbs={currentBreadcrumbs} gaEvent='srp' />
        </div>
        {currentCollection.length === 0 ? (
          <SearchResultsEmptyState />
        ) : (
          <ListingGroup
            header={currentHeader}
            isSortingOn={isSortingOn}
            isLoading={isHydrated ? listingsStore.isLoading : false}
            totalListings={currentTotal}
            listings={currentCollection}
            markListingAsSaved={currentMarkListingAsSaved}
          />
        )}
      </React.Fragment>
    )
  }
)

export default SearchListings
